import { HereLayer } from '../types';

export const getNoisePresentation = (
  getIcon: HereLayer['getIcon'],
  onClick: HereLayer['onClick'],
  { data, position, iconsCache }: any,
  layerName: string
) => {
  const {
    url,
    height,
    width,
    anchorX,
    anchorY,
    id = ''
  } = getIcon({ data });

  const cachedIcon = iconsCache[id];
  let noiseIcon: H.map.Icon = cachedIcon;

  if (!noiseIcon) {
    noiseIcon = new window.H.map.Icon(url, {
      size: {
        w: width / 2,
        h: height / 2
      },
      anchor: {
        x: anchorX ? anchorX / 2 : 0,
        y: anchorY ? anchorY / 2 : 0,
      }
    });

    iconsCache[id] = noiseIcon;
  }

  const noiseMarker = new window.H.map.Marker(position, {
    icon: noiseIcon,
    min: 0,
    volatility: true,
    data: {
      type: 'marker',
      layerName,
      data
    }
  });

  noiseMarker.addEventListener('tap', ({ target }: any) => {
    // @ts-ignore
    const { data, type } = target && target.getData ? target.getData() : {};
    if (onClick) {
      // @ts-ignore
      onClick({
        data,
        markerType: type
      });
    }
  });

  return noiseMarker;
}